import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentActivity = () => {
  const activities = [
    {
      id: 1,
      type: 'booking',
      title: 'New booking received',
      description: 'Sarah Johnson booked 2 tickets for Tech Conference 2024',
      amount: '$298.00',
      time: '2 minutes ago',
      icon: 'CreditCard',
      status: 'success'
    },
    {
      id: 2,
      type: 'checkin',
      title: 'Attendee checked in',
      description: 'Michael Chen checked in to Design Workshop',
      time: '15 minutes ago',
      icon: 'CheckCircle',
      status: 'info'
    },
    {
      id: 3,
      type: 'payment',
      title: 'Payment processed',
      description: 'Batch payment of $1,250 processed successfully',
      amount: '$1,250.00',
      time: '1 hour ago',
      icon: 'DollarSign',
      status: 'success'
    },
    {
      id: 4,
      type: 'event',
      title: 'Event published',
      description: 'Marketing Summit 2024 is now live and accepting bookings',
      time: '3 hours ago',
      icon: 'Calendar',
      status: 'info'
    },
    {
      id: 5,
      type: 'refund',
      title: 'Refund requested',
      description: 'Alex Thompson requested refund for cancelled attendance',
      amount: '-$149.00',
      time: '5 hours ago',
      icon: 'RefreshCcw',
      status: 'warning'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'success': return 'text-success bg-success/10';
      case 'warning': return 'text-warning bg-warning/10';
      case 'info': return 'text-primary bg-primary/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
          <p className="text-sm text-muted-foreground">Latest updates from your events</p>
        </div>
        
        <Button variant="outline" size="sm">
          <Icon name="ExternalLink" size={16} className="mr-2" />
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted/50 transition-smooth">
            <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${getStatusColor(activity?.status)}`}>
              <Icon name={activity?.icon} size={18} />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <h4 className="text-sm font-medium text-foreground truncate">
                  {activity?.title}
                </h4>
                {activity?.amount && (
                  <span className={`text-sm font-semibold ${
                    activity?.amount?.startsWith('-') ? 'text-error' : 'text-success'
                  }`}>
                    {activity?.amount}
                  </span>
                )}
              </div>
              
              <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
                {activity?.description}
              </p>
              
              <div className="flex items-center justify-between mt-2">
                <span className="text-xs text-muted-foreground">{activity?.time}</span>
                
                {activity?.type === 'refund' && (
                  <div className="flex items-center space-x-2">
                    <Button variant="ghost" size="xs">
                      <Icon name="Eye" size={14} className="mr-1" />
                      Review
                    </Button>
                    <Button variant="ghost" size="xs">
                      <Icon name="MessageCircle" size={14} className="mr-1" />
                      Contact
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <Button variant="ghost" fullWidth className="justify-center">
          <Icon name="RotateCcw" size={16} className="mr-2" />
          Refresh Activity Feed
        </Button>
      </div>
    </div>
  );
};

export default RecentActivity;